// Custom Turbo confirm z przezroczystym tłem (styl identyczny jak AI modal)
import { Turbo } from "@hotwired/turbo-rails"

Turbo.setConfirmMethod((message, _element) => {
  return new Promise((resolve) => {
    const overlay = document.createElement("div")
    overlay.className = "fixed inset-0 z-50"
    overlay.innerHTML = `
      <div class="fixed inset-0 bg-gray-500/75" data-confirm-backdrop></div>
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4">
          <div class="relative w-full max-w-md rounded-lg bg-white shadow-xl">
            <div class="px-6 py-5">
              <p class="text-sm text-gray-700">${escapeHtml(message)}</p>
            </div>
            <div class="flex justify-end gap-3 border-t border-gray-200 px-6 py-4">
              <button data-confirm-action="cancel"
                class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                Anuluj
              </button>
              <button data-confirm-action="ok"
                class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    `

    document.body.appendChild(overlay)

    // fokus na OK
    overlay.querySelector("[data-confirm-action='ok']").focus()

    function close(result) {
      document.removeEventListener("keydown", handleKeydown)
      overlay.remove()
      resolve(result)
    }

    overlay.querySelector("[data-confirm-action='cancel']").onclick = () => close(false)
    overlay.querySelector("[data-confirm-action='ok']").onclick = () => close(true)
    overlay.querySelector("[data-confirm-backdrop]").onclick = () => close(false)

    function handleKeydown(e) {
      if (e.key === "Escape") {
        close(false)
      }
    }
    document.addEventListener("keydown", handleKeydown)
  })
})

function escapeHtml(text) {
  const div = document.createElement("div")
  div.textContent = text
  return div.innerHTML
}
